import type { RouteParamsRequest } from '@pba/react-utils';
import { type ApiClientResponse, apiClient } from 'common/services';
import type { EntityDataObject } from 'models/service';
import { routes } from './routes';

type LeaveCommunityRouteParams = {
  id: string;
};

export const leaveCommunity = async ({ routeParams: { id } }: RouteParamsRequest<LeaveCommunityRouteParams>) =>
  apiClient.delete<EntityDataObject, ApiClientResponse<EntityDataObject>>(routes.community.leave(id));
